import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { onAuthStateChanged, signInWithPopup, signOut, GoogleAuthProvider } from "firebase/auth";

function Login(props) {
    const provider = new GoogleAuthProvider();
    
    useEffect(() => {
        onAuthStateChanged(props.auth, user => {
            if (user) {
                props.setUser(user);

                user.getIdToken(/* forceRefresh */ true).then(idToken => {
                    props.setToken(idToken);
                }).then(() => {
                    return fetch(window.__RUNTIME_CONFIG__.API_URL + "/v1/my", {
                        headers: {
                            Authorization: "Bearer " + props.token
                        }
                    }).then(response => response.ok ? response.json() : response.json().then(response => Promise.reject(response)));
                }).then(result => {
                    props.setAdmin(result.admin);
                }).catch(error => {
                    let message = error.error == null ? error : error.error;

                    props.notify(null, "error", message);
                });
            } else {
                props.setUser(null);
                props.setToken(null);
                props.setAdmin(false);
            }
        });
    });

    const loginWithGoogle = () => {
        signInWithPopup(props.auth, provider)
            .then(result => {
                props.setUser(result.user);
            }).catch(error => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorMessage);
            });
    };

    const logoutWithGoogle = () => {
        signOut(props.auth)
            .then(() => {
                props.setUser(null);
            }).catch(error => {
                const errorCode = error.code;
                const errorMessage = error.message;
                alert(errorMessage);
            })
    };

    if (props.user) {
        return (
            <Box display="flex" justifyContent="flex-end">
                <Button color="inherit" onClick={logoutWithGoogle}>
                    Logout
                    &nbsp;
                    <Avatar alt={props.user.displayName} src={props.user.photoURL} />
                </Button>
            </Box>
        )
    }
    else {
        return (
            <Box display="flex" justifyContent="flex-end">
                <Button color="inherit" onClick={loginWithGoogle}>
                    Login
                </Button>
            </Box>
        )
    }
}

export default Login;